import fetch from '../utils/fetch'

export function searchAPI(data) {
    return fetch({
        url:  '/tool/search',
        method: "get",
        params: data,
    })
}
